import { SVGIconProps } from './types'

export const ResetInstanceIcon = ({ ...props }: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87508 4.1139C4.02695 4.26577 4.02695 4.512 3.87508 4.66387L1.42785 7.11111H8.26676C8.48154 7.11111 8.65565 7.28522 8.65565 7.5C8.65565 7.71478 8.48154 7.88889 8.26676 7.88889H1.42785L3.87508 10.3361C4.02695 10.488 4.02695 10.7342 3.87508 10.8861C3.72321 11.038 3.47698 11.038 3.32511 10.8861L0.214001 7.77499C0.06213 7.62312 0.06213 7.37688 0.214001 7.22501L3.32511 4.1139C3.47698 3.96203 3.72321 3.96203 3.87508 4.1139Z"
        fill="currentColor"
      />
      <path
        d="M8.94452 1.64272C8.75423 1.45243 8.44572 1.45243 8.25543 1.64272L5.69814 4.2H7.07633L8.59997 2.67635L13.4236 7.5L8.59997 12.3236L6.97633 10.7H5.59814L8.25543 13.3573C8.44572 13.5476 8.75423 13.5476 8.94452 13.3573L14.4573 7.84455C14.6475 7.65426 14.6475 7.34574 14.4573 7.15545L8.94452 1.64272Z"
        fill="currentColor"
        style={{ opacity: 0.3 }}
      />
    </svg>
  )
}
